import Header from "@/components/feature/Header";
import Footer from "@/components/feature/Footer";
import Hero from "./components/Hero";
import CategoryGrid from "./components/CategoryGrid";
import ValueProps from "./components/ValueProps";
import SeoSection from "./components/SeoSection";
import PillarArticles from "./components/PillarArticles";
import FaqSection from "./components/FaqSection";

export default function Home() {
  const siteUrl = import.meta.env.VITE_SITE_URL || "https://usfanssheet.team";

  const websiteSchema = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: "USFans Spreadsheet",
    url: siteUrl,
    description:
      "USFans Spreadsheet 2026 guide: discover finds, compare categories, and learn about QC, shipping, warehouse and safety before you buy. Independent and updated resource hub.",
    inLanguage: ["en", "pl", "es", "fr"],
    publisher: {
      "@type": "Organization",
      name: "USFans Spreadsheet",
      url: siteUrl,
      logo: {
        "@type": "ImageObject",
        url: "https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/2277e9ffbdee9fd651886f1aeeba0d56.jpeg",
      },
    },
  };

  return (
    <div className="min-h-screen bg-background-50">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteSchema) }}
      />
      <Header />
      <main>
        <Hero />
        <CategoryGrid />
        <ValueProps />
        <SeoSection />
        <PillarArticles />
        <FaqSection />
      </main>
      <Footer />
    </div>
  );
}